
import { defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { ScreenInfo } from '@/types'

export default defineComponent({
  components: {
  },

  props: {
    screenInfo: {
      type: Object as PropType<ScreenInfo>,
      default: undefined,
    },
  },

  setup () {
    const router = useRouter()
    return {
      router,
    }
  },
})
